import React, { Component } from "react";
import styles from "./trips.module.scss";
import { withLogisticTrips } from "../../../shared/containers/containerLogisticTrips";
import { NavLink } from "react-router-dom";
import { TextField } from "@material-ui/core";
import { withLogisticRoutes } from "../../../shared/containers/containerLogisticRoutes";
import FilterAndSearchTools from "../FilterTools/FilterAndSearchTools";
import { states } from "../../../reducers/queriesStates";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import ButtonPrimary from "../../../shared/items/contols/buttonPrimary";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CreateTripRouteList from "./CreateTripRouteList";
import TripRoutesList from "./TripRoutesList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import MapRouteView from "../Routes/MapRouteView";
import Preloader from "../../../shared/items/static/preloader";
import getDates from "../../../shared/services/date.service";
import TripControlPointVariation from "./TripControlPointVariation";
import TripControlPointAlarm from "./TripControlPointAlarm";
import TripAlarm from "./TripAlarm";
import { getDaysWeekString } from "../AlarmTools/LogisticDaysWeekService";
import TripRouteAlarm from "./TripRouteAlarm";
import { withAuth } from "../../../shared/containers/containerAuth";

class CreateTrip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChange: false,
      trip: null,
      isMapView: false,
      controlPointVariation: null,
      controlPointAlarm: null,
      route: null,
      isModalContralPointView: false,
      isModalTripAlarm: false,
      isModalTripRouteAlarm: false,
      number: 0,
    };
  }

  componentDidMount() {
    const { onGetLogisticTrip, logisticSelectedTrip } = this.props;

    const tripId = window.location.pathname.replace("/logistic/trips/", "").replace("/", "");

    if (tripId !== "" && tripId !== "/" && tripId !== undefined) {
      onGetLogisticTrip({ id: tripId });
    }

    this.setState({ trip: logisticSelectedTrip });
  }

  componentDidUpdate(preProps) {
    const { logisticSelectedTrip, logisticTripDataState, logisticTrips } = this.props;

    if (logisticSelectedTrip !== null && logisticSelectedTrip.id !== undefined) {
      const tripId = window.location.pathname.replace("/logistic/trips", "");

      if (tripId === "") {
        window.location.href = window.location.pathname + `/${logisticSelectedTrip.id}`;
      }
    }

    if (logisticTripDataState === states.READY && preProps.logisticTripDataState === states.REQUEST) {
      const tripId = window.location.pathname.replace("/logistic/trips/", "");

      const trip = logisticTrips.filter((x) => {
        return x.id === tripId;
      })[0];

      this.setState({ trip: logisticSelectedTrip });
    }
  }

  onCloseClick() {
    const { onSelectLogisticTrip, onSetViewPanel, viewPanelItems } = this.props;
    onSelectLogisticTrip(null);
    onSetViewPanel(viewPanelItems.tripsList);
  }

  onHandleChangeStore(name, value, number = false) {
    const { trip } = this.state;

    trip[name] = number ? parseInt(value === "" || value === null ? "0" : value) : value;
    this.setState({ trip: trip, isChange: trip.title !== "" && trip.title !== null });
  }

  onSaveHandler() {
    const { trip } = this.state;
    const { onUpdateLogisticTrip } = this.props;

    onUpdateLogisticTrip(trip);
    this.setState({ isChange: false });
  }

  onGetGeojsonData() {
    const { onGetLogisticTripGeoJson, logisticSelectedTrip } = this.props;

    onGetLogisticTripGeoJson({ id: logisticSelectedTrip.id });
    this.setState({ isMapView: true });
  }

  onCloseRouteMap() {
    const { onSelectLogisticTrip, logisticSelectedTrip } = this.props;

    logisticSelectedTrip.geojsonData = null;
    onSelectLogisticTrip(logisticSelectedTrip);
    this.setState({ isMapView: false });
  }

  onSetControlPointVariation(variation, route, number) {
    const { controlPointVariation, isModalContralPointView } = this.state;

    if (variation !== null && isModalContralPointView) {
      return;
    }

    if ((variation === null && controlPointVariation !== null) || (variation !== null && controlPointVariation === null)) {
      this.setState({
        controlPointVariation: JSON.parse(JSON.stringify(variation)),
        route,
        isModalContralPointView: variation !== null,
        number: number,
      });
    }
  }

  onSetControlPointAlarm(alarm, route) {
    const { controlPointAlarm, isModalContralPointView } = this.state;

    if (alarm !== null && isModalContralPointView) {
      return;
    }

    if ((alarm === null && controlPointAlarm !== null) || (alarm !== null && controlPointAlarm === null)) {
      this.setState({ controlPointAlarm: JSON.parse(JSON.stringify(alarm)), route, isModalContralPointView: alarm !== null });
    }
  }

  onSetTripAlarmView(isModalTripAlarm) {
    const { logisticSelectedTrip } = this.props;
    if (isModalTripAlarm && logisticSelectedTrip.unit === null) return;

    this.setState({ isModalTripAlarm });
  }

  onSetTripRouteAlarmView(isModalTripRouteAlarm, route) {
    this.setState({ isModalTripRouteAlarm, route });
  }

  render() {
    const { trip, isChange, isMapView, controlPointVariation, route, controlPointAlarm, isModalTripAlarm, isModalTripRouteAlarm, number } =
      this.state;
    const { onGetLogisticRoutes, logisticSelectedTrip, logisticTripGeojsonDataState, data } = this.props;

    if (trip === null || logisticSelectedTrip === null) return null;

    let controlPoints = [];

    if (
      logisticSelectedTrip.geojsonData !== undefined &&
      logisticSelectedTrip.geojsonData !== null &&
      logisticSelectedTrip.geojsonData.tripGeometries !== null &&
      logisticSelectedTrip.routes.length > 0
    ) {
      logisticSelectedTrip.routes.forEach((r) => {
        if (r.controlPoints.length > 0) controlPoints = controlPoints.concat(r.controlPoints);
      });
    }

    const height = window.innerHeight > 800 ? 650 : 450;

    const tripStartTime = getDates.hoursAndMinutes(logisticSelectedTrip.alarm.time);
    const tripEndTime = getDates.timeAddMinuts(logisticSelectedTrip.alarm.time, logisticSelectedTrip.alarm.duration);
    const daysWeekString = getDaysWeekString(logisticSelectedTrip.alarm.day);

    const tripUpdatePermission = data.permissions.includes(29003);
    const tripGeoJsonPermission = data.permissions.includes(29007);
    const tripCPPermission = data.permissions.includes(31001);

    return (
      <div className={styles.createTripContainer}>
        <div className={styles.toolPanel}>
          <FilterAndSearchTools onFilter={onGetLogisticRoutes} titleSearch={"Поиск по маршрутам"} />

          <div
            onClick={() => {
              this.onCloseClick();
            }}
          >
            <TooltipWrapper title={"Закрыть"} position="left">
              <NavLink to={`/logistic/trips`}>
                <HighlightOffIcon style={{ color: "red" }} />
              </NavLink>
            </TooltipWrapper>
          </div>
        </div>

        <div className={styles.inLineToolContauiner}>
          <div className={styles.createInputs}>
            <div className={styles.createTripInputContainer}>
              <TextField
                id="outlined-basic"
                label="Наименование рейса *"
                variant="outlined"
                size="small"
                fullWidth={true}
                value={trip.title === null ? "" : trip.title}
                onChange={(e) => {
                  this.onHandleChangeStore("title", e.target.value);
                }}
              />
            </div>

            <div className={styles.createControlPointInputContainer} style={{ marginLeft: "30px" }}>
              <textarea
                style={{ width: "400px", fontFamily: "Open Sans" }}
                rows={2}
                value={trip.description === null ? "" : trip.description}
                onChange={(e) => {
                  this.onHandleChangeStore("description", e.target.value);
                }}
              />
            </div>
          </div>

          {isChange && tripUpdatePermission ? (
            <div>
              <ButtonPrimary title={"Обновить текстовую иформацию"} handleClick={this.onSaveHandler.bind(this)}></ButtonPrimary>
            </div>
          ) : null}
        </div>

        <div className={styles.createTripToolContainer}>
          {logisticSelectedTrip.routes.length > 0 && tripGeoJsonPermission ? (
            <TooltipWrapper title={`Просмотреть маршрут рейса на карте`} position="top">
              <div
                className={styles.createTripToolSeeContainer}
                onClick={(e) => {
                  e.stopPropagation();
                  this.onGetGeojsonData();
                }}
              >
                <VisibilityIcon fontSize="small" /> <div> Просмотреть маршрут</div>
                {logisticTripGeojsonDataState === states.REQUEST ? (
                  <div style={{ paddingLeft: "10px" }}>
                    <Preloader size={20} />
                  </div>
                ) : null}
              </div>
            </TooltipWrapper>
          ) : null}

          {logisticSelectedTrip.unit !== null ? (
            <div className={styles.tripAlarmContainer}>
              <TooltipWrapper title={`Изменить расписание рейса`} position="top">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onSetTripAlarmView(true);
                  }}
                >
                  {logisticSelectedTrip.alarm.active ? (
                    <div className={styles.createTripToolAlarmOnContainer}>
                      <AlarmOnIcon fontSize="small" /> {daysWeekString} c {tripStartTime} по {tripEndTime} активно.
                    </div>
                  ) : (
                    <div className={styles.createTripToolAlarmOffContainer}>
                      <AlarmOffIcon fontSize="small" /> {daysWeekString} c {tripStartTime} по {tripEndTime} не активно
                    </div>
                  )}
                </div>
              </TooltipWrapper>
            </div>
          ) : null}
        </div>

        <div className={styles.hederTables}>
          <div style={{ width: "40%" }}>
            <b>Доступные маршруты</b>
          </div>
          <div>
            <b>Выбранные маршруты</b>
          </div>
        </div>

        <div style={{ display: "flex", width: "100%" }}>
          <CreateTripRouteList />
          <TripRoutesList
            tripCPPermission={tripCPPermission}
            onSetControlPointVariation={this.onSetControlPointVariation.bind(this)}
            onSetControlPointAlarm={this.onSetControlPointAlarm.bind(this)}
            onSetTripRouteAlarmView={this.onSetTripRouteAlarmView.bind(this)}
          />
        </div>

        {isModalTripAlarm ? <TripAlarm onSetTripAlarmView={this.onSetTripAlarmView.bind(this)} /> : null}

        {isModalTripRouteAlarm && route !== null ? (
          <TripRouteAlarm tripId={trip.id} route={route} onSetTripRouteAlarmView={this.onSetTripRouteAlarmView.bind(this)} />
        ) : null}

        {controlPointVariation !== null && route !== null ? (
          <TripControlPointVariation
            routeId={route.id}
            tripId={trip.id}
            controlPoint={controlPointVariation}
            number={number}
            onSetControlPointVariation={this.onSetControlPointVariation.bind(this)}
          />
        ) : null}

        {controlPointAlarm !== null && route !== null ? (
          <TripControlPointAlarm
            routeId={route.id}
            tripId={trip.id}
            controlPoint={controlPointAlarm}
            onSetControlPointAlarm={this.onSetControlPointAlarm.bind(this)}
          />
        ) : null}

        {isMapView &&
        logisticSelectedTrip.geojsonData !== undefined &&
        logisticSelectedTrip.geojsonData !== null &&
        logisticSelectedTrip.geojsonData.tripGeometries !== null &&
        logisticSelectedTrip.routes.length > 0 ? (
          <div className={styles.routeMapwrapper}>
            <MapRouteView
              controlPoints={controlPoints}
              geojsonData={logisticSelectedTrip.geojsonData}
              height={height + 200}
              onCloseHandler={this.onCloseRouteMap.bind(this)}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withAuth(withLogisticRoutes(withLogisticTrips(React.memo(CreateTrip))));
